<template>
  <v-layout>
    <v-dialog :modelValue="dialog" @click:outside="closeDialog()" @keydown.esc="closeDialog()" fullscreen transition="dialog-bottom-transition">
      <v-card>
        <v-form ref="form" v-on:submit.prevent="importar($event)">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text style="margin-bottom: 80px">
            <!-- START FORM DIALOG -->
            <v-row align="center" justify="center" class="mb-4 mt-4">
              <v-col md="10" class="elevation-1 pt-4 pb-4" style="background: #f5f5f5">
                <a-steps :current="step">
                  <a-step v-for="item in steps" :key="item.title" :title="item.title" />
                </a-steps>
              </v-col>
            </v-row>

            <div class="steps-content">
              <!--step 0-->
              <v-row align="start" justify="center" v-if="step == 0" transition="fade-transition">
                <v-col md="6" class="mt-4 pr-0 pl-0">
                  <v-form ref="form_step0" class="form-step0-excel">
                    <div class="px-2 py-1 mb-3 bg-subtitle-section">
                      <p class="text-subtitle-1 mb-0">
                        <b>{{ steps[0].title }}</b>
                      </p>
                    </div>
                    <v-label>
                      Descargar la plantilla de importacion de envíos.
                      <v-label @click="downloadExcel" class="text-download font-weight-bold ms-1 me-1"> Descargar </v-label>
                    </v-label>

                    <v-file-input
                      class="mt-3"
                      accept=".xlsx"
                      label="Seleccionar excel"
                      v-model="excelFile"
                      hint="Solo admite archivos formato .xlsx (No admite formato .xls)"
                      persistent-hint
                    ></v-file-input>
                  </v-form>
                </v-col>
              </v-row>

              <!--step 2-->
              <v-row align="start" justify="center" v-if="step == 1" transition="fade-transition">
                <v-col md="10" class="mt-4 pr-0 pl-0">
                  <v-form ref="form_step1">
                    <div class="px-2 py-1 mb-3 bg-subtitle-section">
                      <p class="text-subtitle-1 mb-0">
                        <b>{{ steps[1].title }}</b>
                      </p>
                    </div>
                    <v-progress-linear v-model="percent" color="blue-grey" style="height: 25px !important" class="mb-3 mt-3">
                      <strong>{{ Math.ceil(percent) || 0 }}%</strong>
                    </v-progress-linear>

                    <v-data-table :headers="headers" :items="list_bulk" :search="search" :loading="loading_table" class="expandable-rows" :items-per-page="10" hide-default-footer dense>
                      <template v-slot:item="{ item }">
                        <tr>
                          <td class="expand-icon" @click="toggleExpand(item.object.cabecera_num)">
                            <v-icon>
                              {{ expandedRows.includes(item.object.cabecera_num) ? "mdi-chevron-up" : "mdi-chevron-down" }}
                            </v-icon>
                          </td>
                          <td>{{ item.object.date }}</td>
                          <td>{{ item.object.estimated_departure_date }}</td>
                          <td>{{ item.object.document_type.name }}</td>
                          <td>{{ item.object.external_reference }}</td>
                          <td>{{ item.object.almacen.name }}</td>
                          <td>{{ item.object.client.name }}</td>
                          <td>{{ item.object.canal_venta ? item.object.canal_venta.name : "" }}</td>
                          <td>{{ item.object.sub_client ? item.object.sub_client.name : "" }}</td>
                          <td>{{ item.object.receiver }}</td>
                          <td>{{ item.object.address }}</td>
                          <td>{{ item.object.location }}</td>
                          <td>{{ item.object.postal_code }}</td>
                          <td>{{ item.object.provincia.name }}</td>
                          <td style="min-width: 200px" v-if="!item.loading && item.status == 1 && item.msg == '' && !item.status_create">
                            <i class="fa fa-check text-green"></i>
                          </td>
                          <td style="min-width: 200px" v-if="!item.loading && item.status == 1 && item.msg != '' && !item.status_create">
                            <span class="text-red">{{ item.msg }}</span>
                          </td>
                          <td style="min-width: 200px" v-if="!item.loading && item.status == 1 && item.status_create">
                            <span class="text-green">Importado</span>
                          </td>
                          <td style="min-width: 200px" v-if="!item.loading && item.status == 0">
                            {{ "Pendiente de procesado" }}
                          </td>
                          <td style="min-width: 200px" v-if="item.loading">Procesando...</td>
                        </tr>
                        <tr v-if="expandedRows.includes(item.object.cabecera_num)">
                          <td :colspan="headers.length" class="pl-0 pr-0">
                            <v-data-table class="custom-subtable" :headers="headers_presentation" :items="item.object.items_arr" hide-default-footer disable-pagination style="background-color: #ccc">
                              <template v-slot:item="{ item }">
                                <tr>
                                  <td>{{ item.product.sku }}</td>
                                  <td>{{ item.amount }}</td>
                                  <td>{{ item.lote }}</td>
                                  <td>{{ item.serie }}</td>
                                  <td>{{ item.expiration_date }}</td>
                                  <td v-if="isAliasEnabled('descriptivo_1')">{{ item.descriptivo_1 }}</td>
                                  <td v-if="isAliasEnabled('descriptivo_2')">{{ item.descriptivo_2 }}</td>
                                  <td v-if="isAliasEnabled('descriptivo_3')">{{ item.descriptivo_3 }}</td>
                                  <td>{{ item.quality_name }}</td>
                                  <td>{{ item.status_name }}</td>
                                </tr>
                              </template>
                            </v-data-table>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-form>
                </v-col>
              </v-row>
            </div>
          </v-card-text>

          <v-card-actions style="position: fixed; bottom: 0; right: 0; left: 0">
            <v-row align="start" justify="center">
              <v-col cols="10" style="background-color: white">
                <v-btn @click="prev" color="blue-grey" variant="outlined" v-if="step > 0">Atras</v-btn>
                <div class="float-right mr-2" v-if="step == 1">
                  <v-chip color="success" class="mr-2">Importadas: {{ importaciones_creadas }}</v-chip>
                  <v-chip color="error" class="">Fallidas: {{ importaciones_no_creadas }}</v-chip>
                  <v-btn v-if="importaciones_no_creadas > 0" @click="downloadErrorsExcel" color="error" variant="outlined" size="small" class="ml-3"> Descargar Errores </v-btn>
                </div>

                <v-btn class="float-right" variant="outlined" color="primary" @click="readExcel" v-if="step == 0" :disabled="excelFile == null && step == 0"> Siguiente</v-btn>
              </v-col>
              <v-col cols="12" style="background-color: #fafafa; border-top: 1px solid #c1c1c1" class="text-end">
                <v-btn color="error" text @click="closeDialog()">Cerrar</v-btn>
                <v-btn color="success" text type="submit" :disabled="submit_disabled" :loading="loading" v-if="!disabled && step == 1">{{ formBtn }}</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";
import { clientService } from "@/libs/ws/clientService";

import ValidMixin from "@/mixins/ValidMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import AliasMixin from "@/mixins/AliasMixin.vue";
import readXlsxFile from "read-excel-file";
import { wsService } from "@/libs/ws/wsService";
import { SHIPMENT_ORDER_CABECERA_COLUMNS, SHIPMENT_ORDER_ITEMS_COLUMNS } from "@/constants/ExcelColumnMappings";

export default {
  components: {},
  mixins: [ValidMixin, ExportMixin, AliasMixin],
  props: {
    service: Object,
    button_name: String,
    modal_title: String,
    page_title: String,
    formBtn: String,
    dialog: Boolean,
    updateDialog: Function,
    loadList: Function,
    editItem: Object,
  },
  data() {
    return {
      show: false,
      disabled: false,
      loading: false,
      step: 0,
      headers: [
        {},
        {
          title: "Fecha",
          align: "left",
          sortable: true,
          key: "date",
        },
        {
          title: "Fecha estimada de entrega",
          align: "left",
          sortable: true,
          key: "estimated_departure_date",
        },
        {
          title: "Tipo de Documento",
          align: "left",
          sortable: true,
          key: "document_type.name",
        },
        {
          title: "Referencia Externa",
          align: "left",
          sortable: true,
          key: "external_reference",
        },
        {
          title: "Almacén",
          align: "left",
          sortable: true,
          key: "almacen.name",
        },
        {
          title: "Cliente",
          align: "left",
          sortable: true,
          key: "client.name",
        },
        {
          title: "Canal de Venta",
          align: "left",
          sortable: true,
          key: "canal_venta.name",
        },
        {
          title: "Punto de Entrega",
          align: "left",
          sortable: true,
          key: "sub_client.name",
        },
        {
          title: "Destinatario",
          align: "left",
          sortable: true,
          key: "receiver",
        },
        {
          title: "Dirección",
          align: "left",
          sortable: true,
          key: "address",
        },
        {
          title: "Localidad",
          align: "left",
          sortable: true,
          key: "location",
        },
        {
          title: "Código Postal",
          align: "left",
          sortable: true,
          key: "postal_code",
        },
        {
          title: "Provincia",
          align: "left",
          sortable: true,
          key: "provincia.name",
        },
        {
          title: "Resultado",
          align: "left",
          sortable: false,
          key: "msg",
        },
      ],
      steps: [
        {
          title: "Importar Excel",
          description: "Importe el Excel",
          content: "First-content",
        },
        {
          title: "Detalle del Excel",
          description: "Detalle del Excel",
          content: "Second-content",
        },
      ],
      excelFile: null,
      list_bulk: [],
      expandedRows: [],
      loading_create: false,
      importaciones_creadas: 0,
      importaciones_no_creadas: 0,
      total_importaciones: 0,
      submit_disabled: false,
      progress: 0,
      loading_table: false,
    };
  },
  watch: {},
  mounted() {},

  computed: {
    // Headers dinámicos para la tabla de items expandible
    // Los descriptivos se muestran solo si están habilitados en el sistema (AliasMixin)
    headers_presentation() {
      const baseHeaders = [
        { title: "Producto", key: "product.sku", sortable: false },
        { title: "Cantidad", key: "amount", sortable: false },
        { title: "Lote", key: "lote", sortable: false },
        { title: "Serie", key: "serie", sortable: false },
        { title: "Fecha de Expiracion", key: "expiration_date", sortable: false },
      ];

      // Agregar descriptivos dinámicamente si están habilitados (usando AliasMixin)
      // NOTA: Los descriptivos siempre existen en el Excel (columnas I, J, K) pero solo se muestran si están habilitados
      for (let i = 1; i <= 3; i++) {
        const descriptiveKey = `descriptivo_${i}`;
        if (this.isAliasEnabled(descriptiveKey)) {
          baseHeaders.push({
            title: this.getAliasName(descriptiveKey), // Obtener nombre dinámico del sistema
            align: "left",
            sortable: false,
            key: descriptiveKey,
          });
        }
      }

      // Agregar headers finales
      baseHeaders.push({ title: "Calidad", key: "quality_name", sortable: false }, { title: "Estado de Producto", key: "status_name", sortable: false });

      return baseHeaders;
    },
    percent: {
      get() {
        return ((this.getProcesadosValidos() + this.getProcesadosNoValidos()) * 100) / this.list_bulk.length;
      },
      set(value) {
        return value;
      },
    },
  },

  methods: {
    downloadExcel() {
      const params = {}; // Agregar parámetros si son necesarios
      const fileName = "plantilla_orden_envio.xlsx";

      this.exportExcel(this.service.section + "/get-sample-excel", params, fileName);
    },
    getProcesadosValidos() {
      if (this.list_bulk.length == 0) {
        return 0;
      }
      return this.list_bulk.filter((element) => element.status === 1 && element.status_create).length;
    },
    getProcesadosNoValidos() {
      if (this.list_bulk.length == 0) {
        return 0;
      }
      return this.list_bulk.filter((element) => element.status === 1 && !element.status_create).length;
    },

    toggleExpand(id) {
      if (this.expandedRows.includes(id)) {
        this.expandedRows = this.expandedRows.filter((rowId) => rowId !== id);
      } else {
        this.expandedRows.push(id);
      }
    },
    async readExcel() {
      this.step++;
      this.list_bulk = [];
      this.loading_table = true;
      try {
        const rowsSheet1 = await readXlsxFile(this.excelFile, {
          sheet: 1,
          dateFormat: "YYYY-MM-DD",
        });
        console.log("Rows Sheet 1:", rowsSheet1);
        const rowsSheet2 = await readXlsxFile(this.excelFile, {
          sheet: 2,
          dateFormat: "YYYY-MM-DD",
        });

        // Validar que no haya cabeceras duplicadas
        const validationError = this.validateDuplicateHeaders(rowsSheet1);
        if (validationError) {
          this.toast.error(validationError);
          this.loading_table = false;
          return;
        }

        for (const element of rowsSheet1.slice(1)) {
          const obj = {
            object: await this.parseObject(element, rowsSheet2),
            msg: "",
            status: 0,
            status_create: false,
            loading: false,
          };
          this.list_bulk.push(obj);
        }
      } catch (error) {
        console.error(error);
        this.toast.error("Error al leer el archivo Excel");
      } finally {
        this.loading_table = false;
      }
    },
    async parseObject(element, rowsSheet2) {
      const object = Object.assign({}, this.mainItem);

      // Usar constantes del archivo ExcelColumnMappings.js
      // Si cambia el orden de columnas, solo modificar las constantes
      const cabecera_num = element[SHIPMENT_ORDER_CABECERA_COLUMNS.CABECERA_NUM]; // Se usa para relacionar con items
      
      // Convertir fecha a string YYYY-MM-DD si es Date object
      object.date = element[SHIPMENT_ORDER_CABECERA_COLUMNS.FECHA] instanceof Date 
        ? element[SHIPMENT_ORDER_CABECERA_COLUMNS.FECHA].toISOString().split("T")[0] 
        : element[SHIPMENT_ORDER_CABECERA_COLUMNS.FECHA] ? formatUtils.formatDate(element[SHIPMENT_ORDER_CABECERA_COLUMNS.FECHA]) : null;
      
      console.log("Fecha formateada:", object.date, "Original:", element[SHIPMENT_ORDER_CABECERA_COLUMNS.FECHA]);
      
      object.estimated_departure_date = element[SHIPMENT_ORDER_CABECERA_COLUMNS.FECHA_ESTIMADA_ENTREGA] 
        ? (element[SHIPMENT_ORDER_CABECERA_COLUMNS.FECHA_ESTIMADA_ENTREGA] instanceof Date 
          ? element[SHIPMENT_ORDER_CABECERA_COLUMNS.FECHA_ESTIMADA_ENTREGA].toISOString().split("T")[0] 
          : formatUtils.formatDate(element[SHIPMENT_ORDER_CABECERA_COLUMNS.FECHA_ESTIMADA_ENTREGA])) 
        : null;
      
      object.document_type_name = element[SHIPMENT_ORDER_CABECERA_COLUMNS.TIPO_DOCUMENTO];
      object.external_reference = element[SHIPMENT_ORDER_CABECERA_COLUMNS.REFERENCIA_EXTERNA] ? element[SHIPMENT_ORDER_CABECERA_COLUMNS.REFERENCIA_EXTERNA].toString() : null;
      object.almacen_name = element[SHIPMENT_ORDER_CABECERA_COLUMNS.ALMACEN];
      object.client_name = element[SHIPMENT_ORDER_CABECERA_COLUMNS.CLIENTE];
      object.canal_venta_name = element[SHIPMENT_ORDER_CABECERA_COLUMNS.CANAL_VENTA] || null;
      object.sub_client_name = element[SHIPMENT_ORDER_CABECERA_COLUMNS.PUNTO_ENTREGA] || null;
      object.receiver = element[SHIPMENT_ORDER_CABECERA_COLUMNS.DESTINATARIO];
      object.address = element[SHIPMENT_ORDER_CABECERA_COLUMNS.DIRECCION];
      object.reference = element[SHIPMENT_ORDER_CABECERA_COLUMNS.REFERENCIA_DIRECCION] || null;
      object.location = element[SHIPMENT_ORDER_CABECERA_COLUMNS.LOCALIDAD];
      object.postal_code = element[SHIPMENT_ORDER_CABECERA_COLUMNS.CODIGO_POSTAL] ? element[SHIPMENT_ORDER_CABECERA_COLUMNS.CODIGO_POSTAL].toString() : "";
      object.provincia_name = element[SHIPMENT_ORDER_CABECERA_COLUMNS.PROVINCIA];
      object.telephone = element[SHIPMENT_ORDER_CABECERA_COLUMNS.TELEFONO] ? element[SHIPMENT_ORDER_CABECERA_COLUMNS.TELEFONO].toString() : null;
      object.email = element[SHIPMENT_ORDER_CABECERA_COLUMNS.EMAIL] || null;

      // Para mostrar en la tabla
      object.document_type = { name: element[SHIPMENT_ORDER_CABECERA_COLUMNS.TIPO_DOCUMENTO] };
      object.almacen = { name: element[SHIPMENT_ORDER_CABECERA_COLUMNS.ALMACEN] };
      object.client = { name: element[SHIPMENT_ORDER_CABECERA_COLUMNS.CLIENTE] };
      object.canal_venta = element[SHIPMENT_ORDER_CABECERA_COLUMNS.CANAL_VENTA] ? { name: element[SHIPMENT_ORDER_CABECERA_COLUMNS.CANAL_VENTA] } : null;
      object.sub_client = element[SHIPMENT_ORDER_CABECERA_COLUMNS.PUNTO_ENTREGA] ? { name: element[SHIPMENT_ORDER_CABECERA_COLUMNS.PUNTO_ENTREGA] } : null;
      object.provincia = { name: element[SHIPMENT_ORDER_CABECERA_COLUMNS.PROVINCIA] };

      // Guardar referencia para relacionar con items
      object.cabecera_num = cabecera_num.toString();

      object.items_arr = [];
      rowsSheet2.forEach((row) => {
        if (row[SHIPMENT_ORDER_ITEMS_COLUMNS.CABECERA_NUM] === cabecera_num) {
          object.items_arr.push({
            sku: row[SHIPMENT_ORDER_ITEMS_COLUMNS.SKU].toString(),
            amount: row[SHIPMENT_ORDER_ITEMS_COLUMNS.CANTIDAD],
            status_name: row[SHIPMENT_ORDER_ITEMS_COLUMNS.ESTADO_PRODUCTO] && row[SHIPMENT_ORDER_ITEMS_COLUMNS.ESTADO_PRODUCTO].trim() !== "" 
              ? row[SHIPMENT_ORDER_ITEMS_COLUMNS.ESTADO_PRODUCTO] 
              : "DISPONIBLE",
            lote: row[SHIPMENT_ORDER_ITEMS_COLUMNS.LOTE] || null,
            serie: row[SHIPMENT_ORDER_ITEMS_COLUMNS.SERIE] || null,
            expiration_date: row[SHIPMENT_ORDER_ITEMS_COLUMNS.FECHA_EXPIRACION] 
              ? (row[SHIPMENT_ORDER_ITEMS_COLUMNS.FECHA_EXPIRACION] instanceof Date 
                ? row[SHIPMENT_ORDER_ITEMS_COLUMNS.FECHA_EXPIRACION].toISOString().split("T")[0] 
                : formatUtils.formatDate(row[SHIPMENT_ORDER_ITEMS_COLUMNS.FECHA_EXPIRACION])) 
              : null,
            quality_name: row[SHIPMENT_ORDER_ITEMS_COLUMNS.CALIDAD] || null,
            // Los descriptivos siempre se leen del Excel (índices 8, 9, 10 = columnas I, J, K)
            // aunque no estén habilitados en el sistema. Se muestran en tabla solo si isAliasEnabled()
            descriptivo_1: row[SHIPMENT_ORDER_ITEMS_COLUMNS.DESCRIPTIVO_1] || null,
            descriptivo_2: row[SHIPMENT_ORDER_ITEMS_COLUMNS.DESCRIPTIVO_2] || null,
            descriptivo_3: row[SHIPMENT_ORDER_ITEMS_COLUMNS.DESCRIPTIVO_3] || null,
            // Para mostrar en tabla
            product: { sku: row[SHIPMENT_ORDER_ITEMS_COLUMNS.SKU].toString() },
          });
        }
      });

      this.total_importaciones = object.items_arr.length;

      return object;
    },

    closeDialog() {
      this.$emit("updateDialog", false);
      this.resetForm();
    },

    resetForm() {
      this.step = 0;
      this.list_bulk = [];
      this.excelFile = null;
      this.expandedRows = [];
      this.importaciones_creadas = 0;
      this.importaciones_no_creadas = 0;
      this.total_importaciones = 0;
      this.submit_disabled = false;
      this.loading = false;
      this.loading_create = false;
      this.loading_table = false;

      // Reset forms si existen
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      if (this.$refs.form_step0) {
        this.$refs.form_step0.reset();
      }
      if (this.$refs.form_step1) {
        this.$refs.form_step1.reset();
      }
    },
    prev() {
      this.step--;
    },

    async importar() {
      var index = 0;
      this.loading_create = true;
      this.submit_disabled = true;

      for (const element of this.list_bulk) {
        if (this.list_bulk[index].msg == "" && !this.list_bulk[index].status_create && this.list_bulk[index].status == 0) {
          this.list_bulk[index].loading = true;
          let result = await this.createItem(this.list_bulk[index].object);

          this.list_bulk[index].loading = false;
          this.list_bulk[index].status = 1;
          this.list_bulk[index].status_create = result.status;
          this.list_bulk[index].msg = result.msg;

          if (result.status) {
            this.importaciones_creadas++;
          } else {
            this.importaciones_no_creadas++;
          }
        }

        index++;
      }

      this.loading_create = false;

      if (this.importaciones_creadas === this.list_bulk.length) {
        this.$emit("updateDialog", false);
        this.resetForm();
        this.$emit("loadList");
      }
    },
    async createItem(item) {
      try {
        const response = await this.service.import_line_excel(item);
        return {
          status: response.status,
          msg: response.msg || (response.status ? "Importación exitosa" : "Error en la importación"),
        };
      } catch (error) {
        return {
          status: false,
          msg: error.response?.data?.msg || error.message || "Error en la importación",
        };
      }
    },

    validateDuplicateHeaders(rowsSheet1) {
      const cabeceras = new Set();
      const duplicadas = [];

      for (const element of rowsSheet1.slice(1)) {
        const cabecera_num = element[0];
        if (cabecera_num) {
          if (cabeceras.has(cabecera_num)) {
            duplicadas.push(cabecera_num);
          } else {
            cabeceras.add(cabecera_num);
          }
        }
      }

      if (duplicadas.length > 0) {
        return `Error: Hay cabeceras duplicadas en el Excel: ${[...new Set(duplicadas)].join(", ")}`;
      }

      return null;
    },

    downloadErrorsExcel() {
      const errorsData = this.list_bulk.filter((item) => item.status === 1 && !item.status_create && item.msg !== "");

      if (errorsData.length === 0) {
        this.$toast.warning("No hay errores para exportar");
        return;
      }

      // Transformar los datos para el backend
      const formattedErrors = errorsData.map((item) => ({
        object: item.object,
        msg: item.msg,
      }));

      const params = {
        errors_data: formattedErrors,
      };
      const fileName = `errores_importacion_ordenes_envio.xlsx`;

      this.exportExcel(this.service.section + "/get-excel-with-errors", params, fileName);
    },
  },
};
</script>
